const tableCellAreas = {
  condition: 'Do you really want to delete this item?'
}

export default tableCellAreas;